import { render, staticRenderFns } from "./ModalImportTracking.vue?vue&type=template&id=4b85fa9c&scoped=true&"
import script from "./ModalImportTracking.vue?vue&type=script&lang=js&"
export * from "./ModalImportTracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b85fa9c",
  null
  
)

export default component.exports